import { Voucher } from 'gql/graphql';
import { Store } from 'store/index';

const getCartVouchers = (store: Store) => (store.cart.cart ? store.cart.cart.vouchers || [] : []) as Voucher[];

export default getCartVouchers;
